import moment from "moment-timezone";
import { defaultStartTime } from "../constans";

function getTimeDistance(type: any) {
  const aaa = moment().subtract(type, "days");
  const bbb = moment().subtract(1, "days");
  const start = moment(aaa).isBefore(moment(defaultStartTime))
    ? moment(defaultStartTime)
    : moment(aaa);
  const end = moment(bbb);
  start.set("hours", 0);
  start.set("seconds", 0);
  start.set("minutes", 0);
  end.set("hours", 23);
  end.set("seconds", 59);
  end.set("minutes", 59);

  return [start, end];
}

function newGetTimeDistance() {
  const start = moment(defaultStartTime, "YYYY-MM-DD hh:mm:ss");
  const end = moment(moment().subtract(1, "days"));
  start.set("hours", 0);
  start.set("seconds", 0);
  start.set("minutes", 0);
  end.set("hours", 23);
  end.set("seconds", 59);
  end.set("minutes", 59);

  return [start, end];
}

export default getTimeDistance;

export { newGetTimeDistance };
